/**
 * Environment configuration module
 * Provides type-safe access to environment variables
 */

export const env = {
  malga: {
    merchantId: process.env["MALGA_MERCHANT_ID"],
    clientId: process.env["MALGA_CLIENT_ID"],
    publicKey: process.env["MALGA_PUBLIC_KEY"]
  }
} as const;

/**
 * Validates that all required environment variables are set
 * @throws Error if any required environment variable is missing
 */
export function validateEnv(): void {
  const required = [
    'MALGA_MERCHANT_ID',
    'MALGA_CLIENT_ID',
    'MALGA_PUBLIC_KEY'
  ];

  const missing = required.filter(
    (key) => !import.meta.env[key]
  );

  if (missing.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missing.join(', ')}\n` +
      'Please check your .env file.'
    );
  }
}
